import { useState } from "react";
import { Alert, Button, Form, Image, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";

function FormDriver({
  rowData,
  handleStatus,
  validated,
  handleSubmit,
  loadingSubmit,
  msgError,
}) {
  const { t } = useTranslation();
  const [img, setImg] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (img) => {
    setShow(true);
    setImg(img);
  };
  return (
    <div>
      {/* DriverNameEn */}
      <Form.Group className="mb-3" controlId="DriverNameEn">
        <Form.Label className="font-SemiBold">{t("DriverNameEn")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("DriverNameEn")}
          value={rowData?.DriverNameEn || ""}
          disabled
        />
      </Form.Group>

      {/* DriverNameAr */}
      <Form.Group className="mb-3" controlId="DriverNameAr">
        <Form.Label className="font-SemiBold">{t("DriverNameAr")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("DriverNameAr")}
          value={rowData?.DriverNameAr || ""}
          disabled
        />
      </Form.Group>
      {/* email */}
      <Form.Group className="mb-3" controlId="PhoneNumber">
        <Form.Label className="font-SemiBold">{t("Email")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("Email")}
          value={rowData?.Email || ""}
          disabled
        />
      </Form.Group>
      {/* PhoneNumber */}
      <Form.Group className="mb-3" controlId="PhoneNumber">
        <Form.Label className="font-SemiBold">{t("Phone Number")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("Phone Number")}
          value={"+" + rowData?.AreaCode + "" + rowData?.PhoneNumber || ""}
          disabled
        />
      </Form.Group>

      {/* address */}
      <Form.Group className="mb-3" controlId="address">
        <Form.Label className="font-SemiBold">{t("Address")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("Address")}
          value={rowData?.Address || ""}
          disabled
        />
      </Form.Group>

      {/* routingNumber */}
      <Form.Group className="mb-3" controlId="routingNumber">
        <Form.Label className="font-SemiBold">{t("routingNumber")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("routingNumber")}
          value={rowData?.RoutingNumber || ""}
          disabled
        />
      </Form.Group>

      {/* accountNumber */}
      <Form.Group className="mb-3" controlId="accountNumber">
        <Form.Label className="font-SemiBold">{t("accountNumber")}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t("accountNumber")}
          value={rowData?.AccountNumber || ""}
          disabled
        />
      </Form.Group>

      {/* socialSecurityNumber */}
      <Form.Group className="mb-3" controlId="socialSecurityNumber">
        <Form.Label className="font-SemiBold">
          {t("socialSecurityNumber")}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={t("socialSecurityNumber")}
          value={rowData?.SocialSecurityNumber || ""}
          disabled
        />
      </Form.Group>

      {/* Driver Image  */}
      <Form.Label className="font-SemiBold ">{t("DriverImage")}</Form.Label>
      <div
        className="img-driver mb-3"
        onClick={() => handleShow(rowData?.DriverImage)}
      >
        <Image alt="image" src={rowData?.DriverImage} className="img-fluid" />
      </div>

      {/* fontLicensePhoto */}
      <Form.Label className="font-SemiBold ">
        {t("fontLicensePhoto")}
      </Form.Label>
      <div
        className="img-driver mb-3"
        onClick={() => handleShow(rowData?.FontLicensePhoto)}
      >
        <Image
          alt="image"
          src={rowData?.FontLicensePhoto}
          className="img-fluid"
        />
      </div>

      {/* backLicensePhoto */}
      <Form.Label className="font-SemiBold ">
        {t("backLicensePhoto")}
      </Form.Label>
      <div
        className="img-driver mb-3"
        onClick={() => handleShow(rowData?.BackLicensePhoto)}
      >
        <Image
          alt="image"
          src={rowData?.BackLicensePhoto}
          className="img-fluid"
        />
      </div>

      {/* driverInsurance */}
      <Form.Label className="font-SemiBold ">{t("driverInsurance")}</Form.Label>
      <div
        className="img-driver mb-3"
        onClick={() => handleShow(rowData?.DriverInsurance)}
      >
        <Image
          alt="image"
          src={rowData?.DriverInsurance}
          className="img-fluid"
        />
      </div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Label className="font-SemiBold">
          {t("Select Status")} :{" "}
        </Form.Label>
        <Form.Check
          inline
          type={"radio"}
          id={`radio`}
          label={t("Accept")}
          name="status"
          className="mx-3"
          value={"Approval"}
          onClick={handleStatus}
          required
        />

        <Form.Check
          inline
          type={"radio"}
          id={`radio`}
          label={t("Reject")}
          name="status"
          value={"Reject"}
          onClick={handleStatus}
          required
        />
        {msgError && (
          <Alert variant="danger" className="mt-3">
            {msgError}
          </Alert>
        )}
        <div className="">
          <Button
            aria-label="Aria label"
            type="submit"
            className="btn-main w-100 mt-4"
            disabled={loadingSubmit}
          >
            <div className="flex-gap-2 justify-content-center">
              {t("Save")}
              {loadingSubmit && (
                <ReactLoading
                  type={"spin"}
                  color={"#c8c8c8"}
                  height={"20px"}
                  width={"20px"}
                />
              )}
            </div>
          </Button>
        </div>
      </Form>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header
          className="p-0 border-0 close-position"
          closeButton
        ></Modal.Header>
        <Modal.Body className="p-0 overflow-hidden">
          <div className="max-h-300 overflow-hidden rounded-2">
            <Image
              alt="image"
              src={img}
              className="img-fluid w-100 max-h-300 overflow-hidden object-fit-cover"
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default FormDriver;
